<h1 class="page-title">I Forgot My Password</h1>
<form *ngIf="!forgotPasswordSuccess" class="form sign-in-form" [formGroup]="forgotPasswordForm"
      (ngSubmit)="onSubmit(forgotPasswordForm.value)">
  <p>Please enter the email associated with your account.</p>
  <div class="field">
    <label for="email" class="label">Email</label>
    <input class="input input--large" formControlName="email" id="email" name="email" type="email" placeholder="" required>
    <div *ngIf="formErrors.email" class="error-message field__error-message">{{ formErrors.email }}</div>
  </div>
  <input class="button" type="submit" value="Send Email">
  <div *ngIf="formError" class="error-message field__error-message">{{formError}}</div>
</form>
<p *ngIf="forgotPasswordSuccess">An email has been sent with the link to reset your password. If you don't receive an
  email within 10 minutes, contact NBRC.</p>
